import React from 'react'
import styled from 'styled-components'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import Button from '@mui/material/Button'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import Typography from '@mui/material/Typography'
import {Visibility, VisibilityOff} from '@mui/icons-material'
import {injectIntl} from 'react-intl'

const Eye = styled(IconButton)`
	&:hover {
		backgroundColor: initial;
	}
`

const Text = styled(Typography)`
	text-align: center;
	margin-top: 16px;
	font-weight: 600;
	font-size: 14px;
`

const Submit = styled(Button)`
	margin: 25px 0;
`

const Fields = ({type, password, repeat, instance, instances, handleRegistration, handleClickPassword, handleChange, handleLogin, intl}) => (
	<React.Fragment>
		{type === 'login' ?
			<React.Fragment>
				<TextField variant="standard"
					onChange={handleChange}
					label={intl.formatMessage({id: "login.login_label"})}
					margin="normal"
					inputProps={{
						name: 'username'
					}}
				/>
				<TextField variant="standard"
					onChange={handleChange}
					label={intl.formatMessage({id: "login.password_label"})}
					margin="normal"
					type={password ? 'text' : 'password'}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<Eye
									onClick={() => handleClickPassword('showPassword')}
								>
									{password ? <Visibility /> : <VisibilityOff />}
								</Eye>
							</InputAdornment>
						)
					}}
					inputProps={{
						name: 'password'
					}}
				/>
				{instances.length > 1 &&
					<FormControl margin="normal" variant="standard">
						<InputLabel>{intl.formatMessage({id: "login.instance"})}</InputLabel>
						<Select
							defaultValue={instance}
							onChange={handleChange}
							inputProps={{
								name: 'instance'
							}}
						>
							{instances.map((item, index) =>
								<MenuItem key={index} value={item}>{item}</MenuItem>
							)}
						</Select>
					</FormControl>
				}
				{!instances.length &&
					<Text>
						{intl.formatMessage({id: "login.not_available"})}
					</Text>
				}
				<Submit
					disabled={!instances.length}
					onClick={handleLogin}
					variant="contained"
					color="primary"
					type="submit"
				>
					{intl.formatMessage({id: "login.signIn"})}
				</Submit>
			</React.Fragment>
			:
			<React.Fragment>
				<TextField variant="standard"
					onChange={handleChange}
					label={intl.formatMessage({id: "login.login_label"})}
					margin="normal"
					inputProps={{
						name: 'newusername'
					}}
				/>
				<TextField variant="standard"
					onChange={handleChange}
					label={intl.formatMessage({id: "login.password_label"})}
					margin="normal"
					type={password ? 'text' : 'password'}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<Eye
									onClick={() => handleClickPassword('showPassword')}
								>
									{password ? <Visibility /> : <VisibilityOff />}
								</Eye>
							</InputAdornment>
						)
					}}
					inputProps={{
						name: 'newpassword'
					}}
				/>
				<TextField variant="standard"
					onChange={handleChange}
					label={intl.formatMessage({id: "login.password_repeat_label"})}
					margin="normal"
					type={repeat ? 'text' : 'password'}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<Eye
									onClick={() => handleClickPassword('showPasswordRepeat')}
								>
									{repeat ? <Visibility /> : <VisibilityOff />}
								</Eye>
							</InputAdornment>
						)
					}}
					inputProps={{
						name: 'passwordRepeat'
					}}
				/>
				{instances.length > 1 &&
					<FormControl margin="normal" variant="standard">
						<InputLabel>Instances</InputLabel>
						<Select
							value={instance}
							onChange={handleChange}
							inputProps={{
								name: 'instance'
							}}
						>
							{instances.map((item, index) =>
								<MenuItem key={index} value={item}>{item}</MenuItem>
							)}
						</Select>
					</FormControl>
				}
				{!instances.length &&
					<Text>
						{intl.formatMessage({id: "login.not_available"})}
					</Text>
				}
				<Submit
					disabled={!instances.length}
					variant="contained"
					color="primary"
					type="submit"
					onClick={handleRegistration}
				>
					{intl.formatMessage({id: "login.signUp"})}
				</Submit>
			</React.Fragment>
		}
	</React.Fragment>
)

export default injectIntl(Fields)
